import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const VWAP = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [color, setColor] = useState("AA2211");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.VWAP_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const VWAP = localChartSetting.option;

        props.onOverlayValueChange({
          ta: "VWAP",
          name: `${t("chart5.TA.VWAP")} (VWAP)`,
          option: {
            color: VWAP.color,
            thickness: VWAP.thickness,
            style: VWAP.style,
            showTracker: VWAP.showTracker,
          },
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const VWAP = props.localChartSetting.VWAP_Option.option;

    setColor(VWAP.color);
    setThickness(parseInt(VWAP.thickness) || thickness);
    setStyle(VWAP.style);
    setShowTracker(VWAP.color.showTracker);

  }, [props.localChartSetting]);

  useEffect(() => {
    props.onOverlayValueChange({
      ta: "VWAP",
      name: `${t("chart5.TA.VWAP")} (VWAP)`,
      option: {
        color: color,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
      },
    });
  }, [color, thickness, style, showTracker]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const VWAP = props.localChartSetting.VWAP_Option.option;

    setColor(VWAP.color);
    setThickness(parseInt(VWAP.thickness) || thickness);
    setStyle(VWAP.style);
    setShowTracker(VWAP.color.showTracker);
  }, [props.isReset]);

  const resetALL = () => {
    setColor("AA2211");
    setThickness(2);
    setStyle("s");
    setShowTracker(true);
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicaloverlay" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeOverLay = (id) => {
    props.removeOverLay(id);
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "VWAP":
        setColor(props.selectedColor);
        break;
    }
  };

  const onColorClick = () => {
    props.onColorClick(color, "VWAP", t("chart5.setting"));
  };
  return (
    <div
      className="menusubitem msiaction techicaloverlay"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeOverLay("VWAP")}></div> */}
      <div className="box-container">
        <span className="span">{t("chart5.TA.VWAP")}&nbsp;(VWAP)</span>
        <IconCloseLight
          className="close-icon"
          onClick={() => removeOverLay("VWAP")}
        />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="menusubitem " id="msi-ta-VWAP">
          <div className="taparamlbl">{t("chart5.technicalAnalysisLine")}</div>
          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-VWAP-p0-color0"
              className="colorpicker"
              value={color}
              data-colorpickerdialogtitle="表示設定"
              style={{ backgroundColor: "#" + color }}
              onClick={onColorClick}
            ></button>

            <div className="inputbox">
              <input
                id="msi-ta-VWAP-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>

            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-VWAP-p0-style">
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-VWAP-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
